import { Action, createReducer, on } from '@ngrx/store';
import * as subscriptionActions from './subscription.actions';
import { StudySubscription } from 'src/app/models/subscription';

export interface SubscriptionState {
  loadingSubscription: boolean;
  subscriptionLoaded: boolean;
  fetchedSubscription: StudySubscription;
}

export const initialSubscriptionState: SubscriptionState = {
  loadingSubscription: false,
  subscriptionLoaded: false,
  fetchedSubscription: null,
};

export const reducer = createReducer(
  initialSubscriptionState,
  on(subscriptionActions.getSubscription, (state) => {
    return {
      ...state,
      loadingSubscription: true,
      subscriptionLoaded: false,
    };
  }),
  on(subscriptionActions.getSubscriptionSuccess, (state, { fetchedSubscription }) => {
    return {
      ...state,
      loadingSubscription: false,
      subscriptionLoaded: true,
      fetchedSubscription,
    };
  }),
  on(subscriptionActions.getSubscriptionError, (state) => {
    return {
      ...state,
      loadingSubscription: false,
      subscriptionLoaded: false,
    };
  }),
  on(subscriptionActions.updateSubscriptionSuccess, (state, { updatedSubscription }) => {
    return {
      ...state,
      fetchedSubscription: updatedSubscription,
    };
  })
);

export function subscriptionReducer(state: SubscriptionState | undefined, action: Action) {
  return reducer(state, action);
}
